<template>
  <core-popup
    :show="show"
    :title="''"
    width="912"
    class-list="learning_center_video_popup"
    :body-style="'noPaddings'"
    @onClickCancel="handleClose"
  >
    <template #body>
      <div :class="$style.video_popup_container">
        <div :class="$style.header__close_icon">
                <svg-sprite
                  :name="'close-1'"
                  :size="24"
                  :type="'regular'"
                  color="#999"
                  @onClick="handleClose"
                />
              </div>
        <div :class="$style.video_frame">
          <iframe
            :src="videoSrc"
            width="864"
            height="480"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          />
        </div>
      </div>
    </template>
  </core-popup>
</template>

<script>
import vgpIconButton from '$$vueCmp/globalButton/withIcon/iconButton.vue';
import CorePopup from '../../../../common/VueComponents/popups/corePopup/corePopup.vue';

export default {
  name: 'LearningCenterVideoPopup',
  components: {
    CorePopup,
    vgpIconButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    youtubeId: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
  computed: {
    videoSrc() {
      const origin = window.location.origin;
      return `https://www.youtube.com/embed/${this.youtubeId}?enablejsapi=1&autoplay=1&modestbranding=1&autohide=1&showinfo=0&controls=1&rel=0&iv_load_policy=3&fs=1&origin=${origin}`;
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style module lang="less">
@import "../../../../../less/_variables.less";
@import "../../../../../less/_mixins.less";

:global(.learning_center_video_popup) {
  :global(.core_popup_block) {
    border-radius: 8px !important;
    width: 912px !important;
    max-width: 912px !important;
    min-width: 912px !important;
    height: 544px !important;
    max-height: 544px !important;
    display: flex !important;
    flex-direction: column !important;
  }

  :global(.body) {
    width: 100% !important;
    height: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}

.video_popup_container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 40px 24px 24px 24px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  box-sizing: border-box;
}

.header__close_icon {
  position: absolute;
  top: 7px;
  right: 7px;
  z-index: 10;
  cursor: pointer;
}

.video_frame {
  width: 864px;
  height: 480px;
  border-radius: 4px;
  background: #000;
  overflow: hidden;
  flex-shrink: 0;

  iframe {
    width: 864px;
    height: 480px;
    border: none;
    border-radius: 4px;
    display: block;
  }
}

.youtube_link {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  color: #1c95e1;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    text-decoration: underline;
    opacity: 1;
  }
}
</style>

